import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";
  import { EoiStatus } from "@/enums/EoiStatus";
  import store from "@/store";
  import { computed } from "vue";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotDeclineModal',
  props: {
    eoiId: {
      type: String,
      required: true,
    },
    lotTitle: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
    },
    moneyHoldId: {
      type: String,
      required: true,
    },
  },
  emits: ["close", "confirm", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }

  const role = computed(() => {
    return store.state?.user?.data?.role;
  });
  const userId = computed(() => {
    return store.state?.user?.data?._id;
  });

  function confirm() {
    close();
    emits("loading");
    store
      .dispatch("eoi/declineEoi", {
        eoiId: props.eoiId,
        moneyHoldId: props.moneyHoldId,
      })
      .then(() => {
        store.dispatch("eoi/getEoiCounter", store.state.user.selectedEstateId);
        emits("confirm");
      })
      .catch((error) => {
        if (error.response.status === 409) {
          emits("confirm");
          toast.error("The action has already been performed.");
        } else {
          toast.error("Something went wrong");
        }
      });
  }

const __returned__ = { toast, emits, props, close, role, userId, confirm, LotAssignmentModal, get EoiStatus() { return EoiStatus }, get store() { return store }, computed, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})